import React from 'react';
import Link from 'gatsby-link';

const PrivacyPage = () => (
  <div className="container-center">
    <h1 style={{ textAlign: 'center' }}>Polityka Prywatności</h1>
    <p>Wyrażam zgodę na przetwarzanie moich danych osobowych w celu udzielenia odpowiedzi na zadane pytanie.</p>
    <p>
      Administratorem Danych Osobowych (Administratorem) jest M@RCO USŁUGI INFORMATYCZNE MAREK KRUPA, ul. Zamkowa 30,
      47-451 Tworków, e-mail: <a href="mailto:biuro@twojabi.net">biuro@twojabi.net</a>
    </p>
    <p>
      Podane w formularzu dane osobowe będą przetwarzane wyłącznie w celu skontaktowania się i udzielenia odpowiedzi na
      zadane pytanie. Dane będą przechowywane przez okres potrzebny do udzielenia odpowiedzi. Po udzieleniu odpowiedzi
      dane mogą być przechowywane przez dłuższy okres jeżeli będzie to wymagane przez przepisy prawa lub będzie
      potrzebne do realizowania interesu publicznego.
    </p>
    <p>
      Po przesłaniu nam swoich danych masz prawo dostępu do treści swoich danych, ich sprostowania, usunięcia,
      ograniczenia przetwarzania, prawo do przenoszenia danych, prawo do wniesienia sprzeciwu, prawo do cofnięcia zgody
      w dowolnym momencie. Masz również prawo do wniesienia skargi do Prezesa Urzędu Ochrony Danych, jeżeli uznasz, że
      przetwarzanie Twoich danych osobowych narusza przepisy ogólnego rozporządzenia o ochronie danych osobowych z dnia
      27 kwietnia 2016 roku. Dane będą przekazywane innym odbiorcom wyłącznie w przypadku wystąpienia obowiązku
      prawnego.
    </p>
    <br />
    <Link to="/" style={{ fontSize: 13, color: '#428bca' }}>
      Wróć do strony głównej
    </Link>
  </div>
);

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/pages/polityka-prywatnosci.js